import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/node_modules/@mui/icons-material/esm/CardGiftcard.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/node_modules/@mui/material/esm/Box/Box.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/node_modules/@mui/material/esm/Button/Button.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/node_modules/@mui/material/esm/Container/Container.js");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/node_modules/@mui/material/esm/Grid/Grid.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/node_modules/@mui/material/esm/Typography/Typography.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["BreadcrumbsWrapperComponent"] */ "/opt/atlassian/pipelines/agent/build/src/components/common/Breadcrumbs/BreadcurmbWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderContainer","default"] */ "/opt/atlassian/pipelines/agent/build/src/components/common/header/HeaderRouter/HeaderRouter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/components/common/header/variants/mobile/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/components/common/offerCard/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/components/desktop/homepageFooter/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/components/mobile/bottomToolbar/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/components/mobile/homepageFooter/index.tsx");
